import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database'
import 'firebase/auth';

// Replace this with your own config details
var prodConfig = {
  apiKey: "AIzaSyA3ASf-t3nCnhQCerrwMRRP8SOjg6-gXyk",
      authDomain: "app.ConstruWise.com",
      databaseURL: "https://multilanguage-dacbe.firebaseio.com",
      projectId: "multilanguage-dacbe",
      storageBucket: "multilanguage-dacbe.appspot.com",
      messagingSenderId: "973007339012"
};

/*var devConfig = {
  apiKey: process.env.REACT_APP_DEV_API_KEY,
    authDomain: process.env.REACT_APP_DEV_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DEV_DATABASE_URL,
    projectId: process.env.REACT_APP_DEV_PROJECT_ID,
    storageBucket: process.env.REACT_APP_DEV_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_DEV_MESSAGING_SENDER_ID,
}*/

const config = prodConfig;
//process.env.NODE_ENV === 'production' ? prodConfig : devConfig;

firebase.initializeApp(config);
firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase 


// WEBPACK FOOTER //
// ./src/config/fbConfig.js